import {
  BrowserRouter,
  Route,
  Routes, 
  useNavigate
} from "react-router-dom";
import "./App.css";

import Header from "./components/header/header.component";
import Footer from "./components/footer/footer.component";

import Home from "./pages/home/home.page";
import RDefinition from "./pages/foundation/r-definition/r-definition.page";

// TODO:
// refact fouter like crw clother
// catch error 404

const App = () => {
  return (
    <div className="App">
      <BrowserRouter>
        <Header/>
        <Routes>
          <Route exact path="/" element={<Home/>} />
          <Route path="/index.htm" element={<Home/>} />
          <Route path="/r-definition" element={<RDefinition/>} />
        </Routes>
        <Footer />
      </BrowserRouter>

    </div>
  );
};

export default App;
